// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"bdeedc06","977":"b5c1254e"}[chunkId] + ".chunk.js";
};